const actionTypes = require('constants/actionTypes');

const showSpinner = name => {
    return {
        type: name,
    };
};

const hideSpinner = name => {
    return {
        type: name,
    };
};

const showPreLoader = () => {
    return showSpinner(actionTypes.SHOW_SPINNER);
};

const hidePreLoader = () => {
    return hideSpinner(actionTypes.HIDE_SPINNER);
};

const showPreLoader2 = () => {
    return showSpinner(actionTypes.SHOW_SPINNER_2);
};

const hidePreLoader2 = () => {
    return hideSpinner(actionTypes.HIDE_SPINNER_2);
};

const setInformationText = informationText => {
    return {
        type: actionTypes.PRELOADER_INFORMATION_TEXT,
        informationText,
    };
};

const setInformationArray = informationArray => {
    return {
        type: actionTypes.PRELOADER_INFORMATION_ARRAY,
        informationArray,
    };
};

export default {
    showPreLoader,
    hidePreLoader,
    showPreLoader2,
    hidePreLoader2,
    setInformationText,
    setInformationArray,
};
